<template>
    <div class="main_center" style="margin: 0 0;padding-top: 8px;">
        <div class="content" style="padding: 16px 16px 5px 16px;">
            <el-form ref="form" :model="form" label-position="left" >
                <el-row :gutter="16">
                    <el-col :span="6">
                        <el-form-item label="统计维度：" label-width="70px">
                            <el-select v-model="form.type" value-key="value" @change="typeListChange"
                                       style="width: 100%">
                                <el-option v-for="(item, index) of typeList" :key="index" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item v-show="typeValue === 1" label="时间周期：" props="dateTime1" label-width="70px">
                            <el-date-picker
                                v-model="form.dateTime1"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                placeholder="选择月"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item v-show="typeValue === 2" label="时间周期：" props="dateTime2" label-width="70px">
                            <el-date-picker
                                v-show="typeValue === 2"
                                v-model="form.dateTime2"
                                type="year"
                                format="yyyy"
                                value-format="yyyy"
                                placeholder="选择年"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item v-show="typeValue === 3" label="时间周期：" props="dateTime3" label-width="70px">
                            <el-date-picker
                                v-show="typeValue === 3"
                                v-model="form.dateTime3"
                                type="daterange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="所属交易中心：" props="tradeId" label-width="100px">
                            <el-select v-model="form.tradeId" clearable value-key="value" style="width: 100%"
                                       @change="searchBtn">
                                <el-option v-for="(item, index) in transactionCenterList" :key="index"
                                           :label="item.orgName"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="" label-width="0">
                            <div>
                                <!-- <el-button plain size="small" type="primary" @click="refresh">重置</el-button> -->
                                <el-button size="small" type="primary" @click="searchBtn">统计</el-button>
                                <el-button size="small" type="primary" @click="exportExcel">导出excel</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <space :left="-16" :right="-16" :bottom="16"/>
            <!-- @sort-change="sortChange" -->
            <el-table size="small" :data="tableData" v-loading="dataListLoading" ref="expertExtractTable"
                      :height="tableMaxHeight" stripe border>
                <el-table-column
                    label="序号"
                    type="index"
                    fixed
                    :index="indexMethod"
                    width="50"
                    align="center"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="采购项目编号" prop="tenderProjectCode" align="left" width="120"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="采购项目名称" prop="tenderProjectName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="包件编号" prop="bidSectionCode" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="包件名称" prop="bidSectionName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="采购项目类型" prop="tradeTypeName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="采购方式" prop="tenderModeName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="是否专门面向中小微企业" prop="tendencyMicro" align="left" width="200"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.tendencyMicro == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="所属区域" prop="regionName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="所属交易中心" prop="tradeOrgName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                    label="上传响应文件家数"
                    prop="uploadBidDocumentsNum"
                    align="left"
                    width="150"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="采购人"
                        prop="tenderee"
                        align="left"
                        width="200"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="采购代理机构"
                        prop="tenderAgencyName"
                        align="left"
                        width="200"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="预算总价（元）"
                    prop="contractReckonPrice"
                    align="left"
                    width="260"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="开标时间" prop="openBidTime" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="成交供应商" prop="winerName" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="发布成交结果公告时间" prop="publishTime" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="成交金额（元）" prop="bidAmount" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="节约率" prop="savingRate" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="投诉情况" prop="isComplaint" align="left" width="120"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isComplaint == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="异议情况" prop="isOppugn" align="left" width="120"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isOppugn == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            >
            </pagination>
        </div>
    </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";
import qs from "qs";
import moment from "moment";

export default {
    name: "expertExtractList",
    components: {
        space,
        Pagination,
    },
    data() {
        return {
            dateTimeList: [
                {name: 1, value: moment().subtract(1, "month").format("YYYY-MM")},
                {name: 2, value: moment().format("YYYY")},
                {
                    name: 3,
                    value: [
                        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                    ],
                },
            ],
            form: {
                type: 1,
                dateTime1: moment().subtract(1, "month").format("YYYY-MM"),
                dateTime2: moment().format("YYYY"),
                dateTime3: [
                    moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                    moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                ],
                tradeId: "", // 交易中心ID
                searchKey: "",
                isassessmentseparation: '',
                isRemote: '',//是否远程异地
                // tenderTime: []
            },
            businessType: "GC",
            moreSearchItem: false,
            typeList: [
                {name: "按月统计", id: 1},
                {name: "按年统计", id: 2},
                {name: "自定义周期", id: 3},
            ],
            typeValue: 1,
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 275,
            inputHtml: "",
            sortParams: {
                prop: "",
                order: "",
            },
            transactionCenterList: [],
            assessmentSeparationList: [
                {name: "全部", id: ""},
                {name: "是", id: 1},
                {name: "否", id: 0},
            ],
        };
    },
    watch: {},
    created() {
        this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
        this.transactionCenterList.unshift({orgName: "全部", id: ""});
    },
    methods: {
        ifmove() {
            // let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_'+this.businessType+'del');
            const hasBtnPermisson = false;
            let tableMaxHeight = document.documentElement.clientHeight - 415 + (hasBtnPermisson ? 0 : 41);
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        exportExcel() {
            const query = qs.stringify(this.dealFilter());
            const url = this.$http.adornUrl(`/api/cgTradeStatistics/exportStatistics?${query}`);
            console.log('url=>>>>',url)
            http://localhost:8012/dgwitness/api/cgTradeStatistics/exportStatistics?tradeIds=&startTime=2026-01-01%2000%3A00%3A00&endTime=2026-01-31%2023%3A59%3A59
            window.open(url);
        },
        searchBtn() {
            this.pageIndex = 1;
            this.getList();
        },
        refresh() {
            this.form = {
                year: new Date().getFullYear(),
                searchKey: "",
                tradeId: "", // 交易中心ID
            };
            this.pageIndex = 1;
            this.getList();
        },
        dateTimeChange(val) {
            this.form.dateTime = val;
        },
        typeListChange(val) {
            // const obj = this.dateTimeList.find((item) => item.name === val);
            // this.form.dateTime = obj.value || null;
            this.typeValue = val;
        },
        // 要求前端请求加时间日期
        dealFilter() {
            const st = " 00:00:00";
            const et = " 23:59:59";
            const obj = {
                tradeIds: this.form.tradeId,
            };
            if (this.typeValue === 1) {
                const ad = moment(this.form.dateTime1).startOf("month").format("DD");
                const ap = moment(this.form.dateTime1).endOf("month").format("DD");
                obj.startTime = this.form.dateTime1 + "-" + ad + st;
                obj.endTime = this.form.dateTime1 + "-" + ap + et;
            }
            if (this.typeValue === 2) {
                obj.startTime = this.form.dateTime2 + "-01-01" + st;
                obj.endTime = this.form.dateTime2 + "-12-31" + et;
            }
            if (this.typeValue === 3) {
                obj.startTime = this.form.dateTime3[0] + st;
                obj.endTime = this.form.dateTime3[1] + et;
            }
            // if (this.form.tenderTime && this.form.tenderTime.length > 0) {
            //     obj.tenderStartTime = this.form.tenderTime[0]
            //     obj.tenderEndTime = this.form.tenderTime[1]
            // }
            return obj;
        },
        getList() {
            this.$http
                .post(`/cgTradeStatistics/list`, {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: this.dealFilter(),
                })
                .then((res) => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                });
        },
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getList();
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
    },
    activated() {
        this.getList();
    },
    mounted() {
        this.ifmove();
        let resizeTag = true;
        let that = this;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
    },
};
</script>
